exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".styles__dropdownMenu___qJPgl{z-index:999;width:140px;position:absolute;top:20px;right:50px;padding-top:20px;font-size:14px;color:#333}.styles__dropDownMenu___1_J2L:hover{display:block}.styles__dropdownMenu___qJPgl ul{box-shadow:0 2px 16px 0 rgba(0,0,0,.1);background:#fff;margin:0;padding:0}.styles__dropdownMenu___qJPgl ul li{padding:10px 20px;list-style:none;cursor:pointer}.styles__dropdownMenu___qJPgl ul li.styles__active___3P0t6{color:#f8d0ca}.styles__dropdownMenu___qJPgl ul li:hover{background:#fff4f2}", ""]);

// exports
exports.locals = {
	"dropdownMenu": "styles__dropdownMenu___qJPgl",
	"dropDownMenu": "styles__dropDownMenu___1_J2L",
	"active": "styles__active___3P0t6"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/menu/styles.css
// module id = 698
// module chunks = 0